// test2498
(2498 && 0);
